<div
  class="font-default relative rounded-sm border-2 bg-white p-4 text-4xl transition-colors select-none"
  [class]="{
    'border-blue-500': appearance() === 'REVEAL',
    'text-blue-500': appearance() === 'REVEAL',

    'bg-gray-300': appearance() === 'SPOILER',
    'border-gray-500': appearance() === 'SPOILER',

    'border-emerald-500': appearance() === 'CORRECT',
    'text-emerald-500': appearance() === 'CORRECT',
  }"
>
  <!-- sizing -->
  <div class="invisible grid grid-cols-1 place-items-center">
    <div class="col-span-1 col-start-1 row-span-1 row-start-1">
      @for (klank of word(); track $index) {
        <span>_</span>
      }
    </div>
    <div class="col-span-1 col-start-1 row-span-1 row-start-1">
      @for (klank of word(); track $index) {
        <span>{{ klank }}</span>
      }
    </div>
  </div>

  <!-- content -->
  @if (appearance() === 'SPOILER') {
    <div class="absolute inset-0 place-content-center text-center text-2xl">
      <div class="tracking-widest" animate.enter="anim-fade-in" animate.leave="anim-fade-out">
        @for (klank of word(); track $index) {
          <span class="text-gray-500">●</span>
        }
      </div>
    </div>
  }
  @if (appearance() !== 'SPOILER') {
    <div class="absolute inset-0 place-content-center text-center">
      <div animate.enter="anim-fade-from-bottom" animate.leave="anim-fade-out">
        @for (klank of word(); track $index) {
          <span>{{ klank }}</span>
        }
      </div>
    </div>
  }
</div>
